import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import BtnGoBack from "../../components/common/btnGoBack";
import Doc3GenPdf from "../../components/report/reportDoc3/doc3GenPdf";
import curriculumService from "../../services/curriculum.service";
import ListItemDoc3 from "../../components/report/reportDoc3/listItemDoc3";
import TitleReport from "../../components/report/titleReport";
import sendListService from "../../services/sendList.service";
type ParamType = {
  sche: string;
  curri: string;
};

const ReportDoc3New = () => {
  // เอาไปดึงหลักสูตรที่เป็น typr === schedule.type
  const Param = useParams<ParamType>();
  const [curriInfo, setCurri3Info] = useState<any>({});

  // const type = Param.type === "tqf" ? "มคอ." : "อชว.";

  const [course, setCourse] = useState<any>([]);
  const [type, setType] = useState("");

  useEffect(() => {
    (async () => {
      await sendListService
        .getCourseBySche(Number(Param.sche), Number(Param.curri))
        .then((res) => {
          res.data.sort((a: any, b: any) =>
            a.course.courseCode.localeCompare(b.course.courseCode)
          );

          setCourse(res.data);
          setType(res.data[0].schedule.type);
        });
    })();
  }, [Param.curri, Param.sche]);
  useEffect(() => {
    (async () => {
      await curriculumService.getById(Number(Param.curri)).then((res) => {
        setCurri3Info(res.data);
      });
    })();
  }, [Param.curri]);

  return (
    <>
      <div className="container">
        <TitleReport scheId={Number(Param.sche)} />
        <div className="col text-start">
          <h5>
            หลักสูตร {curriInfo.shortName}- {curriInfo.name} ({curriInfo.level})
          </h5>
        </div>
        <div className="row mt-3">
          <table className="table table-hover table-responsive">
            <thead className="table-dark">
              <tr>
                <th style={{ width: "15%" }}>รหัสวิชา</th>
                <th>ชื่อวิชา</th>
                <th style={{ width: "10%" }}>หน่วยกิต</th>
                <th>อาจารย์ผู้รับผิดชอบรายวิชา222</th>
                <th>กลุ่มเรียนที่เปิดสอน</th>
                <th>รายการส่ง</th>
                <th style={{ width: "30%" }}>Handle</th>
              </tr>
            </thead>
            <tbody>
              {course.length <= 0 && (
                <tr>
                  <td colSpan={7}>
                    <button className="btn btn-sm btn-danger">
                      <i className="bi bi-file-earmark-x"></i>{" "}
                      ยังไม่มีรายวิชาที่ต้องส่งในกำหนดการนี้ {type}
                    </button>{" "}
                  </td>
                </tr>
              )}

              {course.length > 0 &&
                course.map((course: any) => {
                  return <ListItemDoc3 key={course.id} data={course} />;
                })}
            </tbody>
          </table>

          <Doc3GenPdf
            sche={Number(Param.sche)}
            curri={Number(Param.curri)}
            type={type}
          />
        </div>

        <BtnGoBack />
      </div>
    </>
  );
};

export default ReportDoc3New;
